const routes = [
  {
    path: "/manutencao-tipo-documento",
    name: "manutencao-tipo-documento",
    meta: {
      allowedPermissions: ["tipo_documento_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoDocumento/ManutencaoTipoDocumentoHome.vue"),
  },

  {
    path: "/manutencao-tipo-documento/novo",
    name: "manutencao-tipo-documento-novo",
    meta: {
      allowedPermissions: ["tipo_documento_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoDocumento/ManutencaoTipoDocumentoCad.vue"),
  },

  {
    path: "/manutencao-tipo-documento/editar/:id",
    name: "manutencao-tipo-documento-editar",
    meta: {
      allowedPermissions: ["tipo_documento_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoTipoDocumento/ManutencaoTipoDocumentoEdit.vue"),
  },
];

export default routes;
